var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 260.76,
    height: 212.437,
    viewBox: "0 0 260.76 212.437",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logistics",
    transform: "translate(-2 -7.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2293",
    "data-name": "Path 2293",
    d: "M23.038,46A13.038,13.038,0,1,0,36.076,59.038,13.038,13.038,0,0,0,23.038,46Zm0,17.384a4.346,4.346,0,1,1,4.346-4.346A4.346,4.346,0,0,1,23.038,63.384Z",
    transform: "translate(26.768 130.096)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2294",
    "data-name": "Path 2294",
    d: "M53.038,46A13.038,13.038,0,1,0,66.076,59.038,13.038,13.038,0,0,0,53.038,46Zm0,17.384a4.346,4.346,0,1,1,4.346-4.346A4.346,4.346,0,0,1,53.038,63.384Z",
    transform: "translate(127.148 130.096)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2295",
    "data-name": "Path 2295",
    d: "M65.384,31.038V61.351h8.692V31.038A13.038,13.038,0,0,0,61.038,18H48v8.692H61.038A4.346,4.346,0,0,1,65.384,31.038Z",
    transform: "translate(153.916 36.408)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2296",
    "data-name": "Path 2296",
    d: "M219.3,122.3v30.422a4.346,4.346,0,0,1-4.346,4.346H210.26a28.83,28.83,0,0,0,.348-4.346,30.422,30.422,0,0,0-60.844,0,28.833,28.833,0,0,0,.348,4.346H88.92V96.228H80.228v60.844H79.88a28.832,28.832,0,0,0,.348-4.346,30.422,30.422,0,1,0-60.844,0,28.831,28.831,0,0,0,.348,4.346h-9.04V126.65H23.73v-8.692H10.692v-2.825a4.346,4.346,0,0,1,2.738-4l14.516-5.824a3.242,3.242,0,0,0,.652-.391H62.844a8.718,8.718,0,0,0,8.692-8.692V78.844a8.718,8.718,0,0,0-8.692-8.692H44.939l3.477-8.692H80.228V87.493H88.92V31.038a4.346,4.346,0,0,1,4.346-4.346H106.3V18H93.266A13.077,13.077,0,0,0,80.228,31.038v21.73H48.415a8.648,8.648,0,0,0-8.084,5.476L24.73,97.228l-14.516,5.824A13.086,13.086,0,0,0,2,115.133v41.939a8.718,8.718,0,0,0,8.692,8.692H22.383a30.322,30.322,0,0,0,54.847,0h75.534a30.322,30.322,0,0,0,54.847,0h7.345a13.077,13.077,0,0,0,13.038-13.038V122.3ZM41.462,78.844H62.844V96.228H34.508Zm8.344,95.612a21.73,21.73,0,1,1,21.73-21.73A21.73,21.73,0,0,1,49.806,174.456Zm130.38,0a21.73,21.73,0,1,1,21.73-21.73A21.73,21.73,0,0,1,180.186,174.456Z",
    transform: "translate(0 36.408)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2297",
    "data-name": "Path 2297",
    d: "M48,34h60.844v8.692H48Z",
    transform: "translate(153.916 89.944)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2298",
    "data-name": "Path 2298",
    d: "M44,38h60.844v8.692H44Z",
    transform: "translate(140.532 103.328)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2299",
    "data-name": "Path 2299",
    d: "M38,30h69.536v8.692H38Z",
    transform: "translate(120.456 76.56)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2300",
    "data-name": "Path 2300",
    d: "M32.8,76.881,63.224,92.092a8.744,8.744,0,0,0,7.779,0l30.422-15.211a8.649,8.649,0,0,0,4.8-7.775v-14.7H97.536v14.7L71.46,82.144V48.4L97.536,35.364V45.716h8.692v-14.7a8.649,8.649,0,0,0-4.781-7.775L71.025,8.032a8.744,8.744,0,0,0-7.779,0L32.824,23.243A8.649,8.649,0,0,0,28,31.018V69.106a8.649,8.649,0,0,0,4.8,7.775Zm3.89-41.517,8.692,4.346v14.7h8.692V44.056L62.768,48.4V82.144L36.692,69.106Zm22.756,1.66L84.5,24.5l7.666,3.833L67.114,40.857Zm7.666-21.217L74.78,19.64,49.73,32.165l-7.666-3.833Z",
    transform: "translate(86.996 0)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2301",
    "data-name": "Path 2301",
    d: "M56,30h8.692v8.692H56Z",
    transform: "translate(180.684 76.56)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2302",
    "data-name": "Path 2302",
    d: "M60,42h8.692v8.692H60Z",
    transform: "translate(194.068 116.712)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2303",
    "data-name": "Path 2303",
    d: "M44,34h8.692v8.692H44Z",
    transform: "translate(140.532 89.944)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2304",
    "data-name": "Path 2304",
    d: "M36,36h8.692v8.692H36Z",
    transform: "translate(113.764 96.636)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2305",
    "data-name": "Path 2305",
    d: "M45.75,64.767V44.837l5.619,5.619,6.145-6.145L44.476,31.273a4.346,4.346,0,0,0-6.145,0L25.293,44.311l6.145,6.145,5.619-5.619V64.767Z",
    transform: "translate(77.938 76.561)",
    fill: "#1c6bfe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogistics);
export default __webpack_public_path__ + "static/media/Logistics.560faa2cd5ea5827aa42d81f75a235e6.svg";
export { ForwardRef as ReactComponent };